<template>
    <div class="inquire" v-cloak>
      <div class="data-bg">
      <app-header></app-header>
        <div class="data-banner">
          <div class="data-title-box">
            <p class="data-title"><span>{{ $t('xdata.Nav_xtjc') }}</span></p>
            <span class="data-sub">{{ $t('xdata.Int_tms') }}</span>
          </div>
        </div>
      </div>
      <div class="u-flex u-flex-center data-content">
        <data-item 
          :title="$t('xdata.Int_yjjc')"
          :sub="$t('xdata.Int_yjjct')"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Int_rjjc')"
          :sub="$t('xdata.Int_rjjct')"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Int_wljc')"
          :sub="$t('xdata.Int_wljct')"
        >
        </data-item>
      </div>
      <div class="u-flex u-flex-center data-content">
        <data-item 
          :title="$t('xdata.Int_sjjc')"
          :sub="$t('xdata.Int_sjjct')"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Int_aqjc')"
          :sub="$t('xdata.Int_aqjct')"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Int_gljc')"
          :sub="$t('xdata.Int_gljct')"
        >
        </data-item>
      </div>
      <div class="data-list-box">
        <div class="data-list-bg">
          <div class="data-list">
            <div class="data-list-item u-flex u-flex-between">
              <div class="data-list-item-left">
                <p class="data-list-item-name">{{ $t('xdata.Int_ywfw') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywfwt1') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywfwt2') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywfwt3') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywfwt4') }}</p>
              </div>
              <!-- <img src="@/assets/img/data/service.png" class="data-list-item-right"/> -->
            </div>
          </div>
        </div>
        <div class="data-list-bg">
          <div class="data-list">
            <div class="data-list-item u-flex u-flex-between">
              <img src="@/assets/img/data/service.png" class="data-list-item-right"/>
              <div class="data-list-item-left">
                <p class="data-list-item-name">{{ $t('xdata.Int_ywfl') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywflt1') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywflt2') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Int_ywflt3') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="icome-box u-flex u-flex-between">
        <div class="icome-item u-flex u-flex-column u-flex-xy-center">
          <div class="icome-img-box">
            <img src="@/assets/img/data/tp1.png" />
          </div>
          <span>{{ $t('xdata.Int_icont1') }}</span>
        </div>
        <div class="icome-item u-flex u-flex-column u-flex-xy-center">
          <div class="icome-img-box">
            <img src="@/assets/img/data/tp2.png" />
          </div>
          <span>{{ $t('xdata.Int_icont2') }}</span>
        </div>
        <div class="icome-item u-flex u-flex-column u-flex-xy-center">
          <div class="icome-img-box">
            <img src="@/assets/img/data/tp3.png" />
          </div>
          <span>{{ $t('xdata.Int_icont3') }}</span>
        </div>
        <div class="icome-item u-flex u-flex-column u-flex-xy-center">
          <div class="icome-img-box">
            <img src="@/assets/img/data/tp4.png" />
          </div>
          <span>{{ $t('xdata.Int_icont4') }}</span>
        </div>
        <div class="icome-item u-flex u-flex-column u-flex-xy-center">
          <div class="icome-img-box">
            <img src="@/assets/img/data/tp5.png" />
          </div>
          <span>{{ $t('xdata.Int_icont5') }}</span>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </template>
  
  <script>
  
import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";

export default {
    components: {
      "app-header": Header,
      "app-footer": Footer,
      "data-item": DataItem,
    },
    name: "service",
    data() {
      return {
      };
    },
    mounted() {
    },
    methods: {
    }
  };
  </script>
  <style scoped>
    .data-bg {
      width: 100%;
      background: url('../../assets/img/data_bg.jpg') no-repeat fixed center center / 100% auto;
    }
    .data-banner{
      height: 300px;
      background: rgba(0, 0, 0, 0.3);
    }
    .data-title-box{
      padding-top: 60px;
      width: 1200px;
      margin: 0 auto;
    }
    .data-title{
      font-size: 32px;
      color: #fff;
      margin-bottom: 20px;
    }
    .data-sub{
      font-size: 14px;
      display: inline-block;
      width: 70%;
      color: #fff;
      line-height: 1.5;
    }
    .data-content{
      width: 1200px;
      background: #fff;
      margin: 50px auto;
    }
    .data-item:last-of-type{
      margin-right: 0px;
    }
    .data-list-box{
      padding: 50px 0 100px;
      background: #f4f4f4;
    }
    .data-list-bg{
      padding: 50px 0 80px;
    }
    .data-list{
      width: 1200px;
      padding-left: calc((100vw - 1200px) / 2);
      padding-right: 0px;
      background: #fff;
    }
    .data-list-bg:nth-of-type(2n){
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .data-list-bg:nth-of-type(2n) .data-list{
      padding-right: calc((100vw - 1200px) / 2);
      padding-left: 0px;
    }
    .data-list-item{
      padding: 20px 0;
    }
    .data-list-item:last-of-type{
      border-bottom: none;
    }
    .data-list-item-left{
      width: 600px;
    }
    .data-list-item-right{
      width: 500px;
      position: relative;
      bottom: -70px;
      left: -50px;
      border: 1px solid #f4f4f4;
    }
    .data-list-bg:nth-of-type(2n) .data-list-item-right{
      left: 50px;
    }
    .data-list-item-name{
      font-size: 24px;
      margin-bottom: 40px;
      font-weight: bold;
      position: relative;
      margin-top: 20px;
    }
    .data-list-item-name::after{
      content: '';
      display: block;
      position: absolute;
      bottom: -10px;
      left: 0px;
      width: 100px;
      height: 4px;
      border-radius: 4px;
      background: #009DE4;
    }
    .data-list-item-sub{
      line-height: 1.5;
    }
    .data-list-item-mb{
      margin-bottom: 20px;
    }
    .icome-box{
      width: 1200px;
      margin: 0 auto 80px;
      padding-top: 80px;
    }
    .icome-item img{
      padding: 10px;
      border-radius: 50%;
      background: #009DE4;
      width: 40px;
      height: 40px;
    }
    .icome-item{
      width: 16%;
      border-radius: 8px;
      padding: 40px 20px;
      box-sizing: border-box;
      border: 4px solid #f4f4f4;
    }
    .icome-item span{
      margin-top: 10px;
      font-size: 14px;
      text-align: center;
      color: #333;
      display: inline-block;
      height: 60px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/services/integration.vue